import enUS from './en-US.json' assert { type: 'json' };
import koKR from './ko-KR.json' assert { type: 'json' };
import { Language } from '@/shared/consts/language';

export type Translation = typeof koKR;
export function getTranslation(language: Language): Translation {
  switch (language) {
    case 'en-US':
      return enUS;
    case 'ko-KR':
      return koKR;
    default:
      return enUS;
  }
}
